export class WriteReviewClickedUseCase {
    public execute = () => {
        // tslint:disable-next-line: prefer-type-cast
        const createReviewLink: HTMLElement | null = document.querySelector(
            '.pr-snippet-write-review-link'
        );
        if (createReviewLink) {
            createReviewLink.click();
        }
    };
}
